import { render, staticRenderFns } from "./device-detail-panel.vue?vue&type=template&id=1142f93b&scoped=true"
import script from "./device-detail-panel.vue?vue&type=script&lang=js"
export * from "./device-detail-panel.vue?vue&type=script&lang=js"
import style0 from "./device-detail-panel.vue?vue&type=style&index=0&id=1142f93b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142f93b",
  null
  
)

export default component.exports